<div class="flex md:flex-row sm:flex-col  md:h-20 sm:h-full sm:gap-y-3 md:justify-between md:items-center sm:items-start text-white  bg-[#000e1a] text-base font-medium xl:px-80 md:px-20 sm:px-20">
<ng-container *ngFor="let item of data; let index=index">
    <a class="underline text-white" [href]="authLink(item.link)">{{item.title}}</a>
</ng-container>
</div>
